import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import VietnamImage from '../components/vietnam.png'; // Adjust the path to your image
import GibraltarImage from '../components/gibraltar.png';
import SwitzerlandImage from '../components/switzerland.png';
import NorwayImage from '../components/norway.webp';
import BosniaImage from '../components/bosnia.png';

function Year2025() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
         <h1>2025 Photos</h1>
         <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Vietnam Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/vietnam')} // Redirect to /vietnam
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${VietnamImage})` }}
            ></div>
            <p className="location-name">Vietnam</p>
          </div>
  
          {/* Marbella/Gibraltar Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/gibraltar')} // Redirect to /gibraltar
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${GibraltarImage})` }}
            ></div>
            <p className="location-name">Marbella/Gibraltar</p>
          </div>

          {/* Switzerland Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/switzerland')} // Redirect to /switzerland
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${SwitzerlandImage})` }}
            ></div>
            <p className="location-name">Switzerland</p>
          </div>

          {/* Norway Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/norwayy')} // Redirect to /norwayy
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${NorwayImage})` }}
            ></div>
            <p className="location-name">Norway</p>
          </div>

          {/* Bosnia and Herzegovina Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/bosnia')} // Redirect to /bosnia
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${BosniaImage})` }}
            ></div>
            <p className="location-name">Bosnia and Herzegovina</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2025;